function ssoAuthHeader() {
  const ssoData = JSON.parse(localStorage.getItem("ssoLoginData"));
  const token = ssoData?.token;
  return {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
    role: 7,
  };
}
const ssoGet = async (url) => {
  const res = await fetch(url, {
    headers: ssoAuthHeader(),
  });
  const data = await res.json();
  if (data?.responseStatus?.code == 401) {
    sessionStorage.setItem(
      "sessionExpiredError",
      data?.responseStatus?.error ||
        "Your session has expired. Please log in again.",
    );
    localStorage.clear();
    sessionStorage.removeItem("ssoLoginData");
    window.location.replace("/session-expired");
    return;
  }

  if (!res.ok || data?.responseStatus?.isSuccess === false) {
    throw new Error("SSO API failed");
  }
  return data;
};
const ssoPost = async (url, additionalPayload = {}) => {
  const isSimplePost =
    url.includes("/cart/") || additionalPayload.itemId !== undefined;
  const payload = isSimplePost
    ? additionalPayload
    : {
        isShowChildUserData: true,
        searchText: "",
        selectedIds: [],
        pageSize: 5,
        pageNumber: 1,
        ignorePaging: false,
        sortColumn: "",
        sortType: "",
        filter: {
          contentType: [],
          typeOfContent: [],
          typeOfForm: [],
          lineOfBusiness: [],
          countries: [],
          states: [],
          contentFillable: [],
          userIds: [],
          selectedColumns: [],
          selectedContentOriginators: [],
          contentOriginator: "",
          subscriberId: 0,
        },
        ...additionalPayload,
      };

  const res = await fetch(url, {
    method: "POST",
    headers: ssoAuthHeader(),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (data?.responseStatus?.code == 401) {
    sessionStorage.setItem(
      "sessionExpiredError",
      data?.responseStatus?.error ||
        "Your session has expired. Please log in again.",
    );
    localStorage.clear();
    sessionStorage.removeItem("ssoLoginData");
    window.location.replace("/session-expired");
    return;
  }

  if (!res.ok || data?.responseStatus?.isSuccess === false) {
    throw new Error("SSO API failed");
  }
  return data;
};

const ssoPut = async (url, payload = {}) => {
  const res = await fetch(url, {
    method: "PUT",
    headers: ssoAuthHeader(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();

  if (data?.responseStatus?.code == 401) {
    sessionStorage.setItem(
      "sessionExpiredError",
      data?.responseStatus?.error ||
        "Your session has expired. Please log in again.",
    );
    localStorage.clear();
    sessionStorage.removeItem("ssoLoginData");
    window.location.replace("/session-expired");
    return;
  }

  if (!res.ok || data?.responseStatus?.isSuccess === false) {
    throw new Error("SSO API failed");
  }
  return data;
};

const ssoDelete = async (url, payload = {}) => {
  const res = await fetch(url, {
    method: "DELETE",
    headers: ssoAuthHeader(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();

  if (data?.responseStatus?.code == 401) {
    sessionStorage.setItem(
      "sessionExpiredError",
      data?.responseStatus?.error ||
        "Your session has expired. Please log in again.",
    );
    localStorage.clear();
    sessionStorage.removeItem("ssoLoginData");
    window.location.replace("/session-expired");
    return;
  }

  if (!res.ok || data?.responseStatus?.isSuccess === false) {
    console.error("DELETE API failed:", data);
    throw new Error("SSO API failed");
  }
  return data;
};

export default {
  ssoGet,
  ssoPost,
  ssoPut,
  ssoDelete,
};
